import React, { Component } from "react";
import { Link, withRouter } from "routerCompat";
import { Swiper, SwiperSlide } from "swiper/react";

class SimilarProducts extends Component {
  render() {
    return (
      <main className="similarPro">
        <div className="vendorsTitle DescriptionProTitle">
          <h3>محصولات مشابه </h3>
        </div>
        <Swiper spaceBetween={21} slidesPerView={2}>
          {this.props.similarProducts.map((Item) => (
            <SwiperSlide>
              <Link reloadDocument to={`/product/${Item.id}`}>
                <div className="mainDiveSimilarPro">
                  <div className="similarComImg">
                    <img src={Item.pic} alt="pic" />
                  </div>
                  <div className="similarComName">{Item.name}</div>
                  <div className="priceSimilarCom">
                    {Item.stock < 1 ? (
                      <span className="titleRate stockNoItem">ناموجود</span>
                    ) : (
                      <>
                        <dvi className="mainPrice">
                          <span className="secondary">
                            {Item.price_percent} %
                          </span>
                          <span className="realPrice">
                            {Item.min_price?.toLocaleString()} تومان
                          </span>
                        </dvi>
                        <span className="oldPrice">
                          {Item.old_price?.toLocaleString()}
                        </span>
                      </>
                    )}
                  </div>
                </div>
              </Link>
            </SwiperSlide>
          ))}
        </Swiper>
      </main>
    );
  }
}
export default withRouter(SimilarProducts);
